const FormInput = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  type = "text",
  required = false,
  placeholder,
  disabled = false,
}) => {
  const stateClasses = error
    ? "border-red-300 hover:border-red-400 focus:border-red-500 focus:ring-2 focus:ring-red-100"
    : "border-gray-200 hover:border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100";

  return (
    <div>
      {label && (
        <label
          htmlFor={name}
          className="block text-sm font-medium text-gray-600 mb-1.5"
        >
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <input
        id={name}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        disabled={disabled}
        className={`block w-full text-sm rounded-md border bg-white px-3 py-2 outline-none transition-colors placeholder:text-gray-400
          ${stateClasses}
          ${disabled ? "bg-gray-100 text-gray-400 cursor-not-allowed border-gray-200" : "text-gray-900"}
        `}
      />

      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  );
};

export default FormInput;
